import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=33498c65&scoped=true&"
var script = {}
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=33498c65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33498c65",
  null
  
)

export default component.exports